import { render, staticRenderFns } from "./YourReferralStatus.vue?vue&type=template&id=296973a7&scoped=true"
import script from "./YourReferralStatus.vue?vue&type=script&lang=js"
export * from "./YourReferralStatus.vue?vue&type=script&lang=js"
import style0 from "./YourReferralStatus.vue?vue&type=style&index=0&id=296973a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296973a7",
  null
  
)

export default component.exports